import type { UpdateServiceContract } from 'src/data/services/types/UpdateServiceTypes';

/**
 * expo-updates has no web implementation: a browser loads the deployed bundle on every
 * visit, so there is no OTA channel to check, fetch or reload. checkForUpdate() reports
 * the check as completed rather than failed, because callers read the result as "ran"
 * versus "threw", not as "an update was installed".
 *
 * A sibling, not a Platform.OS branch, because the whole implementation differs and this
 * keeps expo-updates out of the web bundle entirely.
 */
class UpdateServiceWeb implements UpdateServiceContract {
	public checkForUpdate(): Promise<boolean> {
		return Promise.resolve(true);
	}
}

export default new UpdateServiceWeb();
